
import image10 from "../img/nody-تصویر-زمینه-دریا-زیبا-1624243530.jpg"
import "./Footer.css"
export default function Footer(){
    return(
        <div>
           <footer class="contact" id="contact" style={{backgroundImage: "url("+ image10 +")"}}>
            
            <div class="contact1">
                <div className="contact2"><h2>تماس با مربی شنا در تبریز</h2></div>
                <div class="contact-box">
                <div>📞 09377656917</div>
                <div>💬 <a href="https://wa.me/989377656917">واتساپ</a></div>
                <div>📍 تبریز</div>
                </div>
            </div>
            </footer>
        </div>
    )
}